import React, { useCallback, useMemo, useState } from 'react'
import PopoverButton, { PopoverButtonItem } from 'core/elements/button/PopoverButton'
import { HeaderPrimaryActionPortal } from 'core/elements/header/portals'
import { isReadonlyUser } from 'core/utils/helpers'
import ClusterDeploymentFormBYO from '../cluster/deployment/ClusterDeploymentFormBYO'
import ClusterDeploymentFormOpenStack from '../cluster/deployment/ClusterDeploymentFormOpenStack'

/**
 * @summary This component is used to render deploy new cluster button and cluster deployment form
 * Use this component anywhere we need to show deploy new cluster feature
 * @returns {React.ReactNode} The DeployNewCluster component
 */
const DeployNewCluster = ({ children = null }) => {
  const [showOpenStackClusterDeploymentModal, setShowOpenStackClusterDeploymentModal] =
    useState(false)
  const [showBYOClusterDeploymentModal, setShowBYOClusterDeploymentModal] = useState(false)

  if (isReadonlyUser()) {
    return null
  }

  const items: PopoverButtonItem[] = useMemo(
    () => [
      {
        title: 'with Virtualized Nodes',
        onClick: () => {
          setShowOpenStackClusterDeploymentModal(true)
        },
      },
      {
        title: 'with Physical Nodes',
        onClick: () => {
          setShowBYOClusterDeploymentModal(true)
        },
        beta: true,
      },
    ],
    [],
  )

  const handleClose = useCallback(() => {
    setShowOpenStackClusterDeploymentModal(false)
    setShowBYOClusterDeploymentModal(false)
  }, [])

  return (
    <>
      <HeaderPrimaryActionPortal>
        {children}
        <PopoverButton buttonLabel="Deploy New Cluster" items={items} />
      </HeaderPrimaryActionPortal>
      {showOpenStackClusterDeploymentModal && (
        <ClusterDeploymentFormOpenStack onClose={handleClose} />
      )}
      {showBYOClusterDeploymentModal && <ClusterDeploymentFormBYO onClose={handleClose} />}
    </>
  )
}

export default DeployNewCluster
